import { render, staticRenderFns } from "./WorkTypeModal.vue?vue&type=template&id=8a9131d8&"
import script from "./WorkTypeModal.vue?vue&type=script&lang=js&"
export * from "./WorkTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports